export const getGroupDeviceTypeInfo = (devices) => {
  const typeSet = new Set(devices.map((device) => device?.device_type).filter(Boolean));
  const types = [...typeSet];
  return {
    types,
    isUniform: typeSet.size <= 1,
    deviceType: typeSet.size === 1 ? types[0] : null,
  };
};

export const audioLabel = (audio) =>
  audio?.displayName || audio?.name || (audio?.id != null ? `audio ${audio.id}` : 'audio');

/**
 * What ONE siren can be given, from the catalogue: files on every siren
 * (`device_ids` empty), files uploaded to this siren, and — since the backend
 * associates a chosen file automatically — every other file, which will be
 * added to this siren when the command is saved.
 */
export const sirenAudioOptionsFor = (device, allAudio) => {
  const files = Array.isArray(allAudio) ? allAudio.filter(Boolean) : [];
  const universal = files.filter((f) => !Array.isArray(f.device_ids) || f.device_ids.length === 0);
  const own = files.filter(
    (f) =>
      Array.isArray(f.device_ids) &&
      f.device_ids.length > 0 &&
      f.device_ids.some((id) => `${id}` === `${device?.id}`),
  );
  const elsewhere = files.filter((f) => !universal.includes(f) && !own.includes(f));
  return { universal, own, elsewhere };
};
